import { CustomerDataResponseV1 } from 'shared/services/api/models/customerData'
import { LetterboxDocumentV1 } from 'shared/services/api/models/letterbox'

export enum EXTERNAL_SHIPMENT_SERVICE {
  PARCELLAB = 'parcellab'
}
export interface OrderDiscountV1 {
  affectedProductIds: string[]
  amount: number
  discountId: string
  displayName: string
}

export interface OrderBillingAddressV1 {
  city: string
  countryCode: string
  doorCode: string
  extension: string
  id: string
  street: string
  streetNo: string
  type: string
  zip: string
}

export interface OrderPickupStationV1 {
  id: string
  name: string
  postNumber: string
  type: string
}

export interface ExternalCarriersIdsV1 {
  [EXTERNAL_SHIPMENT_SERVICE.PARCELLAB]: string
}
export interface OrderCarrierV1 {
  costs: number
  externalCarrierIds: ExternalCarriersIdsV1
  displayName: string
  identifier: string
  trackingId: string
  trackingUrl: string
}

export interface OrderPaymentV1 {
  paymentKind: string
  paymentProviderTransactionId: string
  paymentStatus: string
}

export interface OrderMasterDataV1 {
  currency: string
  language: string
  orderDate: string
  orderNumber: string
  prescriptionFollows: boolean
  totalAmount: number
  totalAmountDiscountRedpoints: number
  totalAmountDiscounts: number
  totalAmountDiscountVoucher: number
  totalAmountDocuments: number
  totalAmountPrescriptionBonus: number
  totalAmountPrescriptionBonusDiscount: number
  totalAmountPrescriptionBonusToAccount: number
  totalAmountRedeemedRedpoints: number
  totalAmountRedpoints: number
  totalAmountShippingCost: number
}

export interface OrderDocumentPricePerUnitV1 {
  formatted: string
}

export interface OrderDeliveryAddressV1 {
  city: string
  countryCode: string
  doorCode: string
  extension: string
  firstName: string
  id: string
  lastName: string
  pickupStation: OrderPickupStationV1
  salutation: string
  street: string
  streetNo: string
  type: string
  zip: string
}

export interface OrderDocumentPositionV1 {
  amountRedpoints: number
  availability: string
  canonicalURL: string
  isCoolingRequired: boolean
  itemName: string
  itemTax: number
  lineAmount: number
  lineDiscountPercent: number
  lineNum: number
  packagingQuantity: number
  packagingUnit: string
  pharmaForm: string
  prescriptionBonus: number
  pricePerUnit: OrderDocumentPricePerUnitV1
  pzn: string
  quantity: number
  salesPrice: number
  thumbnailURL: string
  entryType: string
  upid: string
  redPointsMultiplier: number
  isFreebie: boolean
}

export enum MedicationType {
  pzn = 'pzn',
  composite = 'composite',
  activeSubstance = 'activeSubstance',
  freetext = 'freetext'
}

export interface ActiveSubstance {
  name: string
  strength: number
  unit: string
}

export interface OrderDocumentPositionERxV1 {
  availability: string
  lineAmount: number
  lineNum: number
  copaymentFree: boolean
  prescriptionDate: string
  prescriptionIssuedTo: string
  packagingQuantity: number
  packagingUnit: string
  pzn?: string
  hashedToken: string
  medicationType: MedicationType
  itemName: string
  pharmaForm: string
  quantity: number
  salesPrice: number
  activeSubstance?: ActiveSubstance
  isProductOnRecord: boolean
}

export interface OrderDocumentsV1 {
  documentPositions: OrderDocumentPositionV1[]
  type: string
}

export interface OrderDocumentsERxV1 {
  documentPositions: OrderDocumentPositionERxV1[]
  type: string
}

export interface SuborderV1 {
  billingAddress: OrderBillingAddressV1
  carrier: OrderCarrierV1
  deliveryAddress: OrderDeliveryAddressV1
  discounts: OrderDiscountV1[]
  documentsToDownload: LetterboxDocumentV1[]
  orderDocuments: OrderDocumentsV1[]
  orderDocumentsERx: OrderDocumentsERxV1[]
  orderType: string
  payment: OrderPaymentV1
  sellerId: string
  sellerName: string
  shippedDate: string
  status: string
  subOrderId: string
  totalAmount: number
  totalAmountDocuments: number
  totalAmountPrescriptionBonus: number
  totalAmountRedpoints: number
}

export interface OrderResponseV1 {
  customerMasterData: CustomerDataResponseV1
  orderMasterData: OrderMasterDataV1
  subOrders: SuborderV1[]
}

export interface OrdersResponseV1 {
  itemsPerPage: number
  orders: OrderResponseV1[]
  page: number
  totalItems: number
  totalPages: number
}

export interface OrderLineItemsResponseItemV1 {
  commercialOrderId: string
  orderId: string
  lineItems: OrderLineItemV1[]
}

export interface OrderLineItemV1 {
  canOpenIncident: boolean
  canRefund: boolean
  categoryCode: string
  categoryLabel: string
  commissionFee: number
  commissionRateVat: number
  commissionVat: number
  createdDate: string
  debitedDate: string
  description: string
  lastUpdatedDate: string
  offerId: number
  offerSku: string
  offerStateCode: string
  orderLineId: string
  orderLineIndex: number
  orderLineState: string
  orderLineStateReasonCode: string
  orderLineStateReasonLabel: string
  price: number
  priceAdditionalInfo: string
  priceUnit: number
  productSku: string
  productTitle?: string
  productImage?: string
  packagingQuantity?: number
  packagingUnit?: string
  pharmaForm: string
  quantity: number
  shippedDate: string
  shippingPrice: number
  totalCommission: number
  totalPrice: number
}

export interface AllowedOrdersForRefundResponseV1 {
  commercialOrderId: string
  orderId: string
  returnAvailable: boolean
}
